export class StockOutDTO{
    id: number;
    stockId: number;
    issuedAt: string;
    issuedBy: string;
    issuedTo: string;
    moduleNo: string;
    jobNo: string;
    shift: string;
    styleId: number;
    issuedQuantity: number;
    createdAt?: Date;
    createdUser?: string | null;
    updatedAt?: Date;
    updatedUser?: string | null;
    versionFlag?: number;
  
    constructor(
      id: number,
      stockId: number,
        issuedAt: string,
        issuedBy: string,
        issuedTo: string,
        moduleNo: string,
        jobNo: string,
        shift: string,
        styleId: number,
        issuedQuantity: number,
      createdAt?: Date,
      createdUser?: string | null,
      updatedAt?: Date,
      updatedUser?: string | null,
      versionFlag?: number,
    ){
        this.id = id;
        this.stockId= stockId,
        this.issuedAt= issuedAt,
        this.issuedBy= issuedBy,
        this.issuedTo= issuedTo,
        this.moduleNo= moduleNo,
        this.jobNo= jobNo,
        this.shift= shift,
        this.styleId= styleId,
        this.issuedQuantity= issuedQuantity,
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }
  
  
  }
  